export const renderWithHTML = (content) => {
	return <div dangerouslySetInnerHTML={{ __html: content }} />
}
